import React from 'react';
import Icon from '../../../components/AppIcon';
import { Button } from '../../../components/ui/Button';
import { formatCurrency, formatLongDate } from '../../../utils/localization';

const EventHeader = ({ event, onAddExpense, onManageParticipants, onAddParticipant }) => {

  return (
    <div className="bg-card rounded-lg border border-border p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="Calendar" size={24} className="text-primary" />
            </div>
            <div>
              <h1 className="text-2xl font-semibold text-foreground">{event?.name}</h1>
              <p className="text-muted-foreground">{formatLongDate(event?.date)}</p>
            </div>
          </div>
          
          <div className="flex items-center gap-6 mt-4">
            <div className="flex items-center gap-2">
              <Icon name="Users" size={16} className="text-muted-foreground" />
              <span className="text-sm text-muted-foreground">
                {event?.participants?.length} participant{event?.participants?.length !== 1 ? 's' : ''}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Receipt" size={16} className="text-muted-foreground" />
              <span className="text-sm text-muted-foreground">
                {event?.expenses?.length} expense{event?.expenses?.length !== 1 ? 's' : ''}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="DollarSign" size={16} className="text-muted-foreground" />
              <span className="text-sm text-muted-foreground">
                {formatCurrency(event?.totalAmount)} total
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            variant="outline"
            iconName="UserPlus"
            iconPosition="left"
            onClick={onAddParticipant}
            className="flex-1 sm:flex-none"
          >
            Add Participant
          </Button>
          <Button
            variant="default"
            iconName="Plus"
            iconPosition="left"
            onClick={onAddExpense}
            className="flex-1 sm:flex-none"
          >
            Add Expense
          </Button>
        </div>
      </div>
      {/* Participants Preview */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-medium text-foreground">Participants</h3>
          <Button
            variant="ghost"
            size="sm"
            iconName="Users"
            iconPosition="left"
            onClick={onManageParticipants}
          >
            Manage
          </Button>
        </div>
        <div className="flex flex-wrap gap-2">
          {event?.participants?.map((participant) => (
            <div
              key={participant?.id}
              className="flex items-center gap-2 bg-muted rounded-full px-3 py-1"
            >
              <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center">
                <span className="text-xs font-medium text-primary-foreground">
                  {participant?.name?.charAt(0)?.toUpperCase()}
                </span>
              </div>
              <span className="text-sm text-foreground">{participant?.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EventHeader;
